import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { ImplementSelectionFilterCrackView, SaveFavouritesParams } from '../../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogComponent } from '../../favourite-dialog/favourite-dialog.component';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { GenericIdNameImplementType, GenericIdNameVMforEQUIPMENT } from '../../setup-implement/setup-implement.model';
import { DashboardImplementCondition, DashboardSearchFilter, EquipmentImplementDetails, EquipmentImplementDetailsRow } from '../dashboard.model';
import { GETDashboardService } from '../dashboard.service';
import { ComponentHistroyDialogComponent } from '../implements-by-equipment/components/component-histroy-dialog/component-histroy-dialog.component';
import { SearchFilters } from '../search-panel/search-panel.model';
import { ImplementCrackViewDialogComponent } from './implement-crack-view-dialog/implement-crack-view-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'implements-crack-view',
  templateUrl: './implements-crack-view.component.html',
  styleUrls: ['./implements-crack-view.component.scss']
})
export class ImplementsCrackViewComponent implements OnInit {

   // Search Parameters
   @Input() searchParameters: SearchFilters = new SearchFilters();

   // Equipment Type / Family
   @Input() familyId: number = 0;

   // Favourite Id
   @Input() favouriteId: number = 0;

   // Favourite Name
   favouriteName: string = "";

   // Default View
   defaultView: number = 2;

   // Indicate whether cracks are present
   hasCracks: boolean = false;

   // Paginator
   @ViewChild(MatPaginator) paginator: MatPaginator;

      // The list of 'core' columns to be displayed for equipment.
      displayedColumns = [
        'Serial Number', 'Unit Number', 'Model', 'Job Site', 'SMU (hrs)', 'Last Inspection'
    ];

       // The dynamically generated list of columns and details for implements.
       detailsArray: Array<Array<string | number | DashboardImplementCondition[]>>;
       detailsArrayEquipment: number[] = [];
   
       columns = [];
       dataSource: any;
       loading: boolean = false;
   
       //new code
       EquipmentdetailsList :EquipmentImplementDetails;
       ImplementypesList :GenericIdNameImplementType[];
       implementTypeListForTable: GenericIdNameVMforEQUIPMENT[] = [];
       implementTypeListForTable_: GenericIdNameVMforEQUIPMENT[] = [];

       IsnoOfCracks:boolean=true;
       IstotalCrackLength:boolean=true;
       IsAvgCrack:boolean=false;
       Isfixed:boolean=false;
       noOfCracks=true
       totalCrackLength=true
       AvgCrack=false
       fixed=false
      
   

  constructor(private _dashboardService: GETDashboardService,
    private _favouritesService: FavouriteDialogService,
    private _route: ActivatedRoute, private _router: Router,
    public dialog: MatDialog,  private readonly _pref: PreferencesService,
  ) { }

  ngOnInit() {
    var itemCount = this.initDisplayedColumns();

    if (this.favouriteId > 0) {
        this.loadfavouriteImp_View()
       // this.loading = true;
       // this.initDataSource(itemCount);
    } else {
        if (this.searchParameters !== undefined && this.searchParameters != null) {
            this.loading = true;
            this.initDataSource2(itemCount);
            this.LoadAllImplementTypesForEquipment(itemCount)
        }
    }
  }

  loadfavouriteImp_View(){
    this.loading=true;
    this._favouritesService.LoadFavouriteDetails(this.favouriteId).subscribe(r => {
        this.favouriteName = r.FavouriteName;  
        //load implementype for favourite    
  var params: ImplementSelectionFilterCrackView = {
    Equipments:[],
    Customers:r.Customers,
    Jobsites:r.Jobsites,
    ImplementTypes:r.ImplementTypes,
    Family:r.Families,

}
this._favouritesService.GetImplementsTypesOnEquipmentForCrackView(params).subscribe(r => {
if (r) {
    this.implementTypeListForTable = r;
   this._favouritesService.GetImplementsTypesOnEquipmentForCrackView_(this.implementTypeListForTable).subscribe(res=>{
       console.log(res)
       this.implementTypeListForTable_=res
       if(this.searchParameters.ImplementTypes!=null)
       {
          
       }
   }) 
}
});

//load equipment for favourite
var params_: DashboardSearchFilter = {
    Customers: r.Customers,
    Jobsites: r.Jobsites,
    Equipment: [],
    Families: r.Families,
    Makes: r.Makes,
    Models: r.Models,
    Implements: r.ImplementTypes,
    NoImplemets :false,
    ImplementTypes:r.ImplementTypes,
    ComponentTypes:[]
    
};

this._dashboardService.GetEquipmentForDashboardSearch(params_).subscribe(r => {
    if(r.Details.length >0){
    if (r != null) {
        this.EquipmentdetailsList = r;               
        this._dashboardService.GetImplementAvailableDashboard(params_, 0).subscribe(r2 => {
            this.ImplementypesList = r2;
           
        });
    }
}
});


});
    
  }
  
  initDisplayedColumns() {
    var itemCount = 0;
    this.displayedColumns.forEach(dcName => {
        this.columns.push({
            columnDef: dcName,
            header: dcName,
            item: itemCount,
            isCore: 1,
            cell: (element: any, i: number) => `${element[i]}`
        });
        itemCount++;
    });

    return itemCount;
}
    initDataSource2(itemCount: number) {
        this.loading=true;
        var params: DashboardSearchFilter = {
            Customers: this.searchParameters.customer,
            Jobsites: this.searchParameters.jobsite,
            Equipment: this.searchParameters.equipment,
            Families: this.searchParameters.family,
            Makes: this.searchParameters.make,
            Models: this.searchParameters.model,
            Implements: this.searchParameters.implement,
            NoImplemets :this.searchParameters.NoImps,
            ImplementTypes:this.searchParameters.ImplementTypes,
            ComponentTypes:this.searchParameters.ComponentTypes
            
        };

        this._dashboardService.GetEquipmentForDashboardSearch(params).subscribe(r => {
            if(r.Details.length >0){
            if (r != null) {
                this.EquipmentdetailsList = r;               
                this._dashboardService.GetImplementAvailableDashboard(params, 0).subscribe(r2 => {
                    this.ImplementypesList = r2;
                    this.loading=false;
                   
                });
            }
        }
        });

    }

    initDataSource(itemCount: number) {

      var params: DashboardSearchFilter = {
          Customers: [],
          Jobsites: [],
          Equipment: [],
          Families: [],
          Makes: [],
          Models: [],
          Implements: [],
          ImplementTypes: [],
          ComponentTypes:[],

          NoImplemets:false
      };

      var params3: SaveFavouritesParams;

      this._favouritesService.LoadFavouriteDetails(this.favouriteId).subscribe(r => {
          if (r != null) {
              params3 = r;

              params.Customers = params3.Customers;
              params.Jobsites = params3.Jobsites;
              params.Families = params3.Families;
              params.Makes = params3.Makes;
              params.Models = params3.Models;

              this.defaultView = params3.DefaultView;
              this.favouriteName = params3.FavouriteName;

              this._dashboardService.GetEquipmentForDashboardFavourite(this.favouriteId).subscribe(result => {
                  if (result != null) {
                      this.detailsArray = result.Details.map(m => {
                          return m.EquipmentRow
                      });
                      this.detailsArrayEquipment = result.Details.map(m2 => {
                          return m2.EquipmentId
                      });

                      this._dashboardService.GetImplementTypesAvailable(params, this.favouriteId).subscribe(r2 => {
                          if (r2) {

                              this._dashboardService.GetImplementConditionForDashboard(this.favouriteId).subscribe(dashCond => {
                                  if (dashCond != null) {

                                      var i: number = 0;
                                      var j: number = 0;
                                      this.hasCracks = dashCond.CracksPresent;

                                      // Loop for each equipment row
                                      dashCond.ImplementCondition.forEach(c1 => {

                                          // Loop for each implement type column
                                          c1.forEach(c2 => {

                                              this.detailsArray[i] = this.detailsArray[i].concat([c2]);
                                              j++;
                                          });

                                          i++;
                                      });

                                      var dataArray = [];
                                      dataArray = r2;
                                      dataArray.forEach(f => {
                                          var x = {
                                              columnDef: f.Name + ":" + f.Id,
                                              header: f.Name,
                                              item: itemCount,
                                              isCore: 0,
                                              cell: (element: any, i: number) => `${element[i]}`
                                          };
                                          this.columns.push(x);
                                          itemCount++;
                                      });

                                      this.displayedColumns = this.columns.map(c => c.columnDef);
                                      //console.log("detailsArray_!", this.detailsArray)
                                      this.dataSource = new MatTableDataSource(this.detailsArray);
                                      this.dataSource.paginator = this.paginator;
                                      this.loading = false;

                                  }
                              });
                          }
                      });
                  }
              });
          }
      });

  }

  ChangeExpand(eq:EquipmentImplementDetailsRow){
      eq.IsExapand = !eq.IsExapand
  }

  ChangeExpandImp(imp:GenericIdNameImplementType){
      imp.IsExpand =!imp.IsExpand;
  }
  getEvalClass(implementCondition: DashboardImplementCondition) {
      var evalClass: string = '';
      var evalcode: string = implementCondition.EvalCode;

      if (this.favouriteId == 0) {
          if (evalcode == 'A' && this.searchParameters.evalA) {
              evalClass = 'WornPctCell evalColorA';
          } else if (evalcode == 'B' && this.searchParameters.evalB) {
              evalClass = 'WornPctCell evalColorB';
          } else if (evalcode == 'C' && this.searchParameters.evalC) {
              evalClass = 'WornPctCell evalColorC';
          } else if (evalcode == 'X' && this.searchParameters.evalX) {
              evalClass = 'WornPctCell evalColorX';
          } else {
              evalClass = 'searchEvalNotSelected';
          }
      }

      else {
          if (evalcode == 'A') {
              evalClass = 'WornPctCell evalColorA';
          } else if (evalcode == 'B') {
              evalClass = 'WornPctCell evalColorB';
          } else if (evalcode == 'C') {
              evalClass = 'WornPctCell evalColorC';
          } else if (evalcode == 'X') {
              evalClass = 'WornPctCell evalColorX';
          }
      }

      return evalClass;
  }

  displayEval(implementCondition: DashboardImplementCondition) {
      if (this.defaultView == 1) {
          return implementCondition.Cracks.toString() + " / " + implementCondition.TotalOP.toString();
      } else if (this.defaultView == 2) {
          return implementCondition.EvalCode;
      } else if (this.defaultView == 3) {
          return implementCondition.WornPct.toString() + "%";
      }
  }
  OpenComponentHistroy(compId:number,system:string){
      const addSectionDialog = this.dialog.open(ComponentHistroyDialogComponent, {
          data: {
              ComponentId:compId,
              System:system
          }
        });
        addSectionDialog.afterClosed().subscribe(details => {
        });
  }

  
  openEquipmentDetails(id) {
      // this._router.navigate(['equipment/', id]);

      const url = this._router.serializeUrl(this._router.createUrlTree(['get-equipment/' + id]));
      //window.open(url, '_blank');
      this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        if(res=="True"){
          this._router.navigate([url]);
        }else{             
            window.open(url, '_blank');
         
        }
    });
  }

  openDFIImplmentDetails(equipmentid:number){
      const url = this._router.serializeUrl(this._router.createUrlTree(['dfi-implementdetails/' + equipmentid]));
    //  window.open(url, '_blank');

    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        if(res=="True"){
          this._router.navigate([url]);
        }else{             
            window.open(url, '_blank');
         
        }
    });
  }
  getProjected(cmu:number, residual:number){
      let val = cmu+ residual;
      return val;

  }
  OpenFavourite() {
      let dialogRef = this.dialog.open(FavouriteDialogComponent, {
          disableClose: true,
          data: {
              favouriteId: this.favouriteId
          }
      });
      dialogRef.afterClosed().subscribe(r => {
          if (r.data != null) {

          } else {

          }
      });
  }

 
  LoadAllImplementTypesForEquipment(itemCount: number){
    var params: ImplementSelectionFilterCrackView = {
            Equipments:this.searchParameters.equipment!=null?this.searchParameters.equipment:[],
            Customers:this.searchParameters.customer!=null?this.searchParameters.customer:[],
            Jobsites:this.searchParameters.jobsite!=null?this.searchParameters.jobsite:[],
            ImplementTypes:this.searchParameters.ImplementTypes!=null?this.searchParameters.ImplementTypes:[],
            Family:this.searchParameters.family!=null?this.searchParameters.family:[],

      }
    this._favouritesService.GetImplementsTypesOnEquipmentForCrackView(params).subscribe(r => {
        if (r) {
            this.implementTypeListForTable = r;
           this._favouritesService.GetImplementsTypesOnEquipmentForCrackView_(this.implementTypeListForTable).subscribe(res=>{
               console.log(res)
               this.implementTypeListForTable_=res
               if(this.searchParameters.ImplementTypes!=null)
               {
                  
               }
           }) 
        }
    });
}

Isprint:boolean=true;
 

//  showValue1(){
    
//    this.Isprint=true;
  
//    return true;
//     }

// showValue1(EquipmentId, e, isPrint){
//     if(EquipmentId==e){
//         isPrint=true; 
//     }
//     console.log(EquipmentId, e)
//    // this.Isprint=true;
//     console.log("ttt__t",isPrint)
// }

showValue2(EquipmentId,im:GenericIdNameVMforEQUIPMENT){
  // console.log("yyyyyy",im.Equipment,im.isPrint, im.Name, EquipmentId)

  var isContains= im.Equipment.filter(x=>x.euipmentID!=null && x.euipmentID== EquipmentId);
//  console.log("isContains",isContains)
  if(isContains.length>0){
      im.isPrint=true
  }

  else  im.isPrint=false
 // console.log("tttyyyy",im.isPrint)
    return true;
    }


    changeCheckbox(values: string) {
        switch (values) {
          case 'noOfCracks':
            this.IsnoOfCracks = !this.IsnoOfCracks;
            break;
          case 'totalCrackLength':
            this.IstotalCrackLength = !this.IstotalCrackLength;
            break;
          case 'AvgCrack':
            this.IsAvgCrack =  !this.IsAvgCrack;
            break;
          case 'fixed':
            this.Isfixed = !this.Isfixed;
            break;
            
        }
        console.log( this.IsnoOfCracks)
        console.log( this.noOfCracks)
      }

      
    openImplemetCrackViewDialog(im:GenericIdNameVMforEQUIPMENT)
    {
     
      const dialogRef = this.dialog.open(ImplementCrackViewDialogComponent, {
        data: { 
            implementTypeListForTable: im,
            EquipmentdetailsList:this.EquipmentdetailsList
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        console.log("res",res)
        if (res ==true) {
               
        
        }
     
      });
      
    }


    //GetDetailsedCompartmentView_
}

